import { create } from 'zustand'

export const enum EKindTab {
  GENERAL = 'INSURANCE',
  ISSUES = 'INSURANCE_ISSUES',
}

export interface IInsuranceManagerState {
  isModalOpened: boolean
  setModalOpened: (value: boolean) => void
  tab: EKindTab
  setTab: (value: EKindTab) => void
}

export const useInsuranceManagerState = create<IInsuranceManagerState>(
  (set) => ({
    isModalOpened: false,
    tab: EKindTab.GENERAL,
    setModalOpened: (isModalOpened) => set({ isModalOpened }),
    setTab: (tab) => set({ tab }),
  })
)
